export default {
  development: {
    BASE_HOST: 'https://rest-test.gongji58.com',
    STUDY_HOST: 'https://study-test.gongji58.com',
    OAUTH_URL: 'https://rest-test.gongji58.com/v1/weixin'
  },
  // production: {
  //   BASE_HOST: 'https://rest-test.gongji58.com',
  //   STUDY_HOST: 'https://study-test.gongji58.com',
  //   OAUTH_URL: 'https://rest-test.gongji58.com/v1/weixin'
  // },
  production: {
    BASE_HOST: 'https://rest.gongji58.com',
    STUDY_HOST: 'https://study.gongji58.com',
    OAUTH_URL: 'https://rest.gongji58.com/v1/weixin'
  },
  test: {
    BASE_HOST: 'https://rest-test.gongji58.com',
    STUDY_HOST: 'https://study-test.gongji58.com',
    OAUTH_URL: 'https://rest-test.gongji58.com/v1/weixin'
  }
};
